import Swiper from "swiper";
import { Navigation, Thumbs, Scrollbar } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {});

jQuery(($) => {
	let initialGallerySlider = 0;
	/* if ($(".swiper-gallery .swiper-slide").length > 0) {
		const totalSlides = $(".swiper-gallery .swiper-slide").length;
		initialGallerySlider = roundUp(totalSlides / 2, 1);
	} */

	let isDragging = false;

	new Swiper(".swiper-gallery", {
		slidesPerView: "auto",
		spaceBetween: 30,
		loop: true,
		centeredSlides: true,
		initialSlide: 2,
		preventClicks: false,
		preventClicksPropagation: false,
		slideToClickedSlide: true,

		navigation: {
			nextEl: ".swiper-button-next-gallery-slider",
			prevEl: ".swiper-button-prev-gallery-slider",
		},
		modules: [Navigation],
		breakpoints: {
			1024: {
				spaceBetween: 30,
			},
			767: {
				spaceBetween: 15,
			},
			0: {
				spaceBetween: 9,
			},
		},
		on: {
			touchStart: function () {
				isDragging = false;
			},
			touchMove: function () {
				isDragging = true;
			},
			touchEnd: function () {
				setTimeout(function () {
					isDragging = false;
				}, 0);
			},
		},
		/* 	scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
			hide: false,
		}, */
	});

	$(".swiper-slide").on("click", function (e) {
		if (isDragging) {
			e.preventDefault();
		} else {
			const linkElement = $(this).find("a.image-link");
			if (linkElement.length > 0) {
				const fancyboxData = linkElement.data("fancybox");
				const href = linkElement.attr("href");

				Fancybox.show([
					{
						src: href,
						type: "video",
						caption: fancyboxData,
					},
				]);

				e.preventDefault();
			}
		}
	});
});
